import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import { FC, ReactElement } from "react";

interface Props {
  icon: FC<any>;
  title: string;
  value: number;
}

const InstructureStatisticItem: FC<Props> = ({ icon, title, value }) => {
  const Icon = icon;
  return (
    <div className="flex gap-1.5">
      <Icon className="h-6 w-6 text-fds-icon-tertiary" />
      <p className="title-md-medium text-fds-secondary">
        {toFarsiNumber(separateMoneyNumbers(String(value)))} {title}
      </p>
    </div>
  );
};

export default InstructureStatisticItem;
